module.exports = __webpack_public_path__ + "img/Pod.8ecbe286.svg";